export default __webpack_public_path__ + "static/media/circleCloud11.67fef272.webp";